// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import Navbar from '../components/Layout/Navbar';
// import { isAuthenticated } from '../utils/auth';
// import api from '../services/api';
// import { EmailConfig, EmailLog } from '../types';
// import EmailConfigForm from '../components/Admin/EmailConfigForm';
// import './EmailConfig.css';

// const EmailConfigPage: React.FC = () => {
//   const navigate = useNavigate();
//   const [activeTab, setActiveTab] = useState('EmailConfig');
//   const [emailConfig, setEmailConfig] = useState<EmailConfig | null>(null);
//   const [emailLogs, setEmailLogs] = useState<EmailLog[]>([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState('');
//   const [showForm, setShowForm] = useState(false);
//   const [editingConfig, setEditingConfig] = useState<EmailConfig | null>(null);
//   const [activeSubTab, setActiveSubTab] = useState<'config' | 'logs'>('config');

//   useEffect(() => {
//     if (!isAuthenticated()) {
//       navigate('/login');
//       return;
//     }
//     fetchData();
//   }, [navigate]);

//   const fetchData = async () => {
//     try {
//       setLoading(true);
//       setError('');
//       const [configResponse, logsResponse] = await Promise.all([
//         api.get('/admin/email-config'),
//         api.get('/admin/email-logs')
//       ]);

//       if (configResponse.data.success) {
//         setEmailConfig(configResponse.data.data || null);
//       } else {
//         setEmailConfig(null);
//         setError(configResponse.data.message || 'Failed to load email configuration');
//       }

//       if (logsResponse.data.success) {
//         setEmailLogs(logsResponse.data.data || []);
//       } else {
//         setEmailLogs([]);
//       }
//     } catch (err: any) {
//       console.error('Error fetching email data:', err);
//       setError(err.response?.data?.message || 'Network error – unable to load data');
//       setEmailConfig(null);
//       setEmailLogs([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleTabChange = (tab: string) => {
//     setActiveTab(tab);
//     navigate(`/${tab.toLowerCase()}`);
//   };

//   const handleEdit = (config: EmailConfig) => {
//     setEditingConfig(config);
//     setShowForm(true);
//   };

//   const handleAdd = () => {
//     setEditingConfig(null);
//     setShowForm(true);
//   };

//   const handleFormClose = () => {
//     setShowForm(false);
//     setEditingConfig(null);
//   };

//   const handleFormSubmit = () => {
//     fetchData();
//     handleFormClose();
//   };

//   const handleDelete = async (id: string) => {
//     if (!window.confirm('Are you sure you want to delete this email configuration?')) return;
//     try {
//       const response = await api.delete(`/admin/email-config/${id}`);
//       if (response.data.success) {
//         fetchData();
//       } else {
//         alert(response.data.message || 'Failed to delete configuration');
//       }
//     } catch (err: any) {
//       alert(err.response?.data?.message || 'Error deleting configuration');
//     }
//   };

//   const formatDate = (dateString: string) => {
//     if (!dateString) return 'N/A';
//     const date = new Date(dateString);
//     return date.toLocaleString('en-US', {
//       year: 'numeric',
//       month: 'short',
//       day: '2-digit',
//       hour: '2-digit',
//       minute: '2-digit',
//       hour12: true
//     });
//   };

//   const maskSecret = (secret?: string) => {
//     if (!secret) return '••••••••';
//     return '••••••••';
//   };

//   if (!isAuthenticated()) return null;

//   if (loading) {
//     return (
//       <div className="email-config-page">
//         <Navbar activeTab={activeTab} onTabChange={handleTabChange} />
//         <div className="page-content">
//           <div className="loading-container">Loading email configurations...</div>
//         </div>
//       </div>
//     );
//   }

//   const getConfigTitle = (config: EmailConfig) => {
//     return config.type === 'gmail' ? '🔐 Gmail API Configuration' : '⚙️ SMTP Configuration';
//   };

//   return (
//     <div className="email-config-page">
//       <Navbar activeTab={activeTab} onTabChange={handleTabChange} />
//       <div className="page-content">
//         <div className="page-header">
//           <h1>📧 Email Configuration</h1>
//           <button className="add-button" onClick={handleAdd}>
//             + Add Email Config
//           </button>
//         </div>

//         {error && <div className="error-message">{error}</div>}

//         <div className="sub-tabs">
//           <button
//             className={`sub-tab ${activeSubTab === 'logs' ? 'active' : ''}`}
//             onClick={() => setActiveSubTab('logs')}
//           >
//             📋 Email Logs
//           </button>
//           <button
//             className={`sub-tab ${activeSubTab === 'config' ? 'active' : ''}`}
//             onClick={() => setActiveSubTab('config')}
//           >
//             ⚙️ Email Configuration
//           </button>
//         </div>

//         {activeSubTab === 'config' && (
//           <>
//             {!emailConfig ? (
//               <div className="no-data">
//                 <p>No email configuration found.</p>
//                 <button className="add-button-secondary" onClick={handleAdd}>
//                   + Configure Email
//                 </button>
//               </div>
//             ) : (
//               <div className="config-grid">
//                 <div className="config-card">
//                   <div className="config-card-header">
//                     <span className="config-title">{getConfigTitle(emailConfig)}</span>
//                     <span className={`active-badge ${emailConfig.is_active ? 'active' : 'inactive'}`}>
//                       {emailConfig.is_active ? '🟢 Active' : '🔴 Inactive'}
//                     </span>
//                   </div>
//                   <div className="config-card-body">
//                     {emailConfig.type === 'smtp' ? (
//                       <div className="config-fields">
//                         <div className="config-row">
//                           <div className="config-label">SMTP Host:</div>
//                           <div className="config-value">{emailConfig.smtp_host}</div>
//                         </div>
//                         <div className="config-row">
//                           <div className="config-label">SMTP Port:</div>
//                           <div className="config-value">{emailConfig.smtp_port}</div>
//                         </div>
//                         <div className="config-row">
//                           <div className="config-label">Username:</div>
//                           <div className="config-value">{emailConfig.smtp_username}</div>
//                         </div>
//                         <div className="config-row">
//                           <div className="config-label">Password:</div>
//                           <div className="config-value">{maskSecret(emailConfig.smtp_password)}</div>
//                         </div>
//                         <div className="config-row">
//                           <div className="config-label">From Email:</div>
//                           <div className="config-value">{emailConfig.from_email}</div>
//                         </div>
//                         <div className="config-row">
//                           <div className="config-label">To Email:</div>
//                           <div className="config-value highlight">{emailConfig.to_email}</div>
//                         </div>
//                       </div>
//                     ) : (
//                       <div className="config-fields">
//                         <div className="config-row">
//                           <div className="config-label">Client ID:</div>
//                           <div className="config-value">{emailConfig.google_client_id}</div>
//                         </div>
//                         <div className="config-row">
//                           <div className="config-label">Client Secret:</div>
//                           <div className="config-value">{maskSecret(emailConfig.google_client_secret)}</div>
//                         </div>
//                         <div className="config-row">
//                           <div className="config-label">Refresh Token:</div>
//                           <div className="config-value">{maskSecret(emailConfig.google_refresh_token)}</div>
//                         </div>
//                         <div className="config-row">
//                           <div className="config-label">Google Email:</div>
//                           <div className="config-value">{emailConfig.google_email}</div>
//                         </div>
//                         <div className="config-row">
//                           <div className="config-label">Admin Email:</div>
//                           <div className="config-value highlight">{emailConfig.admin_email}</div>
//                         </div>
//                         {emailConfig.google_redirect_uri && (
//                           <div className="config-row">
//                             <div className="config-label">Redirect URI:</div>
//                             <div className="config-value">{emailConfig.google_redirect_uri}</div>
//                           </div>
//                         )}
//                       </div>
//                     )}
//                   </div>
//                   <div className="config-card-footer">
//                     <button className="edit-btn" onClick={() => handleEdit(emailConfig)}>
//                       ✏️ Edit
//                     </button>
//                     <button className="delete-btn" onClick={() => handleDelete(emailConfig.id)}>
//                       🗑️ Delete
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </>
//         )}

//         {activeSubTab === 'logs' && (
//           <>
//             {emailLogs.length === 0 ? (
//               <div className="no-data">
//                 <p>No email logs found yet.</p>
//               </div>
//             ) : (
//               <div className="logs-table-container">
//                 <table className="logs-table">
//                   <thead>
//                     <tr>
//                       <th>Date/Time</th>
//                       <th>Call SID</th>
//                       <th>To Email</th>
//                       <th>Subject</th>
//                       <th>Status</th>
//                       <th>Error</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {emailLogs.map((log) => (
//                       <tr key={log.id}>
//                         <td className="date-cell">{formatDate(log.sent_at)}</td>
//                         <td className="sid-cell">{log.call_sid?.substring(0, 15)}...</td>
//                         <td>{log.to_email}</td>
//                         <td className="subject-cell" title={log.subject}>
//                           {log.subject?.length > 40 ? log.subject.substring(0, 40) + '...' : log.subject}
//                         </td>
//                         <td>
//                           <span className={`log-status ${log.status}`}>
//                             {log.status === 'sent' ? '✅ Sent' : '❌ Failed'}
//                           </span>
//                         </td>
//                         <td className="error-cell">{log.error_message || '-'}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             )}
//           </>
//         )}
//       </div>

//       {showForm && (
//         <EmailConfigForm
//           config={editingConfig}
//           onClose={handleFormClose}
//           onSubmit={handleFormSubmit}
//         />
//       )}
//     </div>
//   );
// };

// export default EmailConfigPage;



import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Layout/Navbar';
import { isAuthenticated } from '../utils/auth';
import api from '../services/api';
import { EmailConfig, EmailLog } from '../types';
import EmailConfigForm from '../components/Admin/EmailConfigForm';
import './EmailConfig.css';

const EmailConfigPage: React.FC = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('EmailConfig');
  const [emailConfig, setEmailConfig] = useState<EmailConfig | null>(null);
  const [emailLogs, setEmailLogs] = useState<EmailLog[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [editingConfig, setEditingConfig] = useState<EmailConfig | null>(null);
  // ✅ Changed default from 'config' to 'logs'
  const [activeSubTab, setActiveSubTab] = useState<'config' | 'logs'>('logs');

  useEffect(() => {
    if (!isAuthenticated()) {
      navigate('/login');
      return;
    }
    fetchData();
  }, [navigate]);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError('');
      const [configResponse, logsResponse] = await Promise.all([
        api.get('/admin/email-config'),
        api.get('/admin/email-logs')
      ]);

      if (configResponse.data.success) {
        setEmailConfig(configResponse.data.data || null);
      } else {
        setEmailConfig(null);
        setError(configResponse.data.message || 'Failed to load email configuration');
      }

      if (logsResponse.data.success) {
        setEmailLogs(logsResponse.data.data || []);
      } else {
        setEmailLogs([]);
      }
    } catch (err: any) {
      console.error('Error fetching email data:', err);
      setError(err.response?.data?.message || 'Network error – unable to load data');
      setEmailConfig(null);
      setEmailLogs([]);
    } finally {
      setLoading(false);
    }
  };

  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
    navigate(`/${tab.toLowerCase()}`);
  };

  const handleEdit = (config: EmailConfig) => {
    setEditingConfig(config);
    setShowForm(true);
  };

  const handleAdd = () => {
    setEditingConfig(null);
    setShowForm(true);
  };

  const handleFormClose = () => {
    setShowForm(false);
    setEditingConfig(null);
  };

  const handleFormSubmit = () => {
    fetchData();
    handleFormClose();
  };

  const handleDelete = async (id: string) => {
    if (!window.confirm('Are you sure you want to delete this email configuration?')) return;
    try {
      const response = await api.delete(`/admin/email-config/${id}`);
      if (response.data.success) {
        fetchData();
      } else {
        alert(response.data.message || 'Failed to delete configuration');
      }
    } catch (err: any) {
      alert(err.response?.data?.message || 'Error deleting configuration');
    }
  };

  const formatDate = (dateString: string) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  };

  const maskSecret = (secret?: string) => {
    if (!secret) return '••••••••';
    return '••••••••';
  };

  if (!isAuthenticated()) return null;

  if (loading) {
    return (
      <div className="email-config-page">
        <Navbar activeTab={activeTab} onTabChange={handleTabChange} />
        <div className="page-content">
          <div className="loading-container">Loading email configurations...</div>
        </div>
      </div>
    );
  }

  const getConfigTitle = (config: EmailConfig) => {
    return config.type === 'gmail' ? '🔐 Gmail API Configuration' : '⚙️ SMTP Configuration';
  };

  return (
    <div className="email-config-page">
      <Navbar activeTab={activeTab} onTabChange={handleTabChange} />
      <div className="page-content">
        <div className="page-header">
          <h1>📧 Email Configuration</h1>
          <button className="add-button" onClick={handleAdd}>
            + Add Email Config
          </button>
        </div>

        {error && <div className="error-message">{error}</div>}

        <div className="sub-tabs">
          <button
            className={`sub-tab ${activeSubTab === 'logs' ? 'active' : ''}`}
            onClick={() => setActiveSubTab('logs')}
          >
            📋 Email Logs
          </button>
          <button
            className={`sub-tab ${activeSubTab === 'config' ? 'active' : ''}`}
            onClick={() => setActiveSubTab('config')}
          >
            ⚙️ Email Configuration
          </button>
        </div>

        {activeSubTab === 'config' && (
          <>
            {!emailConfig ? (
              <div className="no-data">
                <p>No email configuration found.</p>
                <button className="add-button-secondary" onClick={handleAdd}>
                  + Configure Email
                </button>
              </div>
            ) : (
              <div className="config-grid">
                <div className="config-card">
                  <div className="config-card-header">
                    <span className="config-title">{getConfigTitle(emailConfig)}</span>
                    <span className={`active-badge ${emailConfig.is_active ? 'active' : 'inactive'}`}>
                      {emailConfig.is_active ? '🟢 Active' : '🔴 Inactive'}
                    </span>
                  </div>
                  <div className="config-card-body">
                    {emailConfig.type === 'smtp' ? (
                      <div className="config-fields">
                        <div className="config-row">
                          <div className="config-label">SMTP Host:</div>
                          <div className="config-value">{emailConfig.smtp_host}</div>
                        </div>
                        <div className="config-row">
                          <div className="config-label">SMTP Port:</div>
                          <div className="config-value">{emailConfig.smtp_port}</div>
                        </div>
                        <div className="config-row">
                          <div className="config-label">Username:</div>
                          <div className="config-value">{emailConfig.smtp_username}</div>
                        </div>
                        <div className="config-row">
                          <div className="config-label">Password:</div>
                          <div className="config-value">{maskSecret(emailConfig.smtp_password)}</div>
                        </div>
                        <div className="config-row">
                          <div className="config-label">From Email:</div>
                          <div className="config-value">{emailConfig.from_email}</div>
                        </div>
                        <div className="config-row">
                          <div className="config-label">To Email:</div>
                          <div className="config-value highlight">{emailConfig.to_email}</div>
                        </div>
                      </div>
                    ) : (
                      <div className="config-fields">
                        <div className="config-row">
                          <div className="config-label">Client ID:</div>
                          <div className="config-value">{emailConfig.google_client_id}</div>
                        </div>
                        <div className="config-row">
                          <div className="config-label">Client Secret:</div>
                          <div className="config-value">{maskSecret(emailConfig.google_client_secret)}</div>
                        </div>
                        <div className="config-row">
                          <div className="config-label">Refresh Token:</div>
                          <div className="config-value">{maskSecret(emailConfig.google_refresh_token)}</div>
                        </div>
                        <div className="config-row">
                          <div className="config-label">Google Email:</div>
                          <div className="config-value">{emailConfig.google_email}</div>
                        </div>
                        <div className="config-row">
                          <div className="config-label">Admin Email:</div>
                          <div className="config-value highlight">{emailConfig.admin_email}</div>
                        </div>
                        {emailConfig.google_redirect_uri && (
                          <div className="config-row">
                            <div className="config-label">Redirect URI:</div>
                            <div className="config-value">{emailConfig.google_redirect_uri}</div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  <div className="config-card-footer">
                    <button className="edit-btn" onClick={() => handleEdit(emailConfig)}>
                      ✏️ Edit
                    </button>
                    <button className="delete-btn" onClick={() => handleDelete(emailConfig.id)}>
                      🗑️ Delete
                    </button>
                  </div>
                </div>
              </div>
            )}
          </>
        )}

        {activeSubTab === 'logs' && (
          <>
            {emailLogs.length === 0 ? (
              <div className="no-data">
                <p>No email logs found yet.</p>
              </div>
            ) : (
              <div className="logs-table-container">
                <table className="logs-table">
                  <thead>
                    <tr>
                      <th>Date/Time</th>
                      <th>Call SID</th>
                      <th>To Email</th>
                      <th>Subject</th>
                      <th>Status</th>
                      <th>Error</th>
                    </tr>
                  </thead>
                  <tbody>
                    {emailLogs.map((log) => (
                      <tr key={log.id}>
                        <td className="date-cell">{formatDate(log.sent_at)}</td>
                        <td className="sid-cell">{log.call_sid?.substring(0, 15)}...</td>
                        <td>{log.to_email}</td>
                        <td className="subject-cell" title={log.subject}>
                          {log.subject?.length > 40 ? log.subject.substring(0, 40) + '...' : log.subject}
                        </td>
                        <td>
                          <span className={`log-status ${log.status}`}>
                            {log.status === 'sent' ? '✅ Sent' : '❌ Failed'}
                          </span>
                        </td>
                        <td className="error-cell">{log.error_message || '-'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </>
        )}
      </div>

      {showForm && (
        <EmailConfigForm
          config={editingConfig}
          onClose={handleFormClose}
          onSubmit={handleFormSubmit}
        />
      )}
    </div>
  );
};

export default EmailConfigPage;